<app-global-alert-main></app-global-alert-main>

<global-nav [multiSelect]="false" [navUrl]="navUrl"></global-nav>

<mat-sidenav-container class="app-container">
    <mat-sidenav
        #sidenav
        fixedInViewport="true"
        fixedTopGap="60"
        [mode]="sidenavMode"
        [opened]="sidenavOpen"
        (openedChange)="triggerResize()"
        class="sidenav-container"
        *ngIf="showSidenav"
    >
        <header class="sidenav-header">
            <div class="left-column">
                <h1 class="page-title" data-automation="listTitle">{{ 'user.list.title' | translate }}</h1>
            </div>

            <div class="right-column" [ngClass]="{ hidden: !showSidenav }">
                <button
                    color="accent"
                    aria-label="Menu"
                    class="toggle-sidenav"
                    data-automation="toggle-sidenav"
                    (click)="sidenav.toggle()"
                >
                    <mat-icon>double_arrow</mat-icon>
                </button>
            </div>
        </header>
        <div class="sidenav-component-container">
            <app-list></app-list>
        </div>
    </mat-sidenav>

    <mat-sidenav-content>
        <button
            mat-icon-button
            color="accent"
            aria-label="Menu"
            class="toggle-sidenav mobile-btn"
            (click)="sidenav.toggle()"
        >
            <mat-icon>menu</mat-icon>
        </button>
        <div class="content-section">
            <div class="main-container">
                <router-outlet></router-outlet>
            </div>
        </div>

        <ngx-global-contact-footer></ngx-global-contact-footer>
    </mat-sidenav-content>
</mat-sidenav-container>
